import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class JwtTokenNestUseCase extends BaseUseCase {
    constructor(jwtTokenRepo) {
        super();
        this.jwtTokenRepo = jwtTokenRepo;
    }
    async fetchResult(data) {
        return await this.jwtTokenRepo.getJwtToken(data);
    }
}
export default JwtTokenNestUseCase;
